module.exports = __webpack_public_path__ + "media/ets/29-128f8086.png";